<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<section class="supplier_fuso_tabs mar-top-20">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#unlisted" role="tab" #unlistNav>{{'Unlisted VS Code' |
        translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#VSCode" role="tab" #createNav>{{'Create New VS Code' | translate}}</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane active" id="unlisted" #unlistPane>
      <section class="">
        <!-- <section class="part_search_bar">
          <div class="col-md-6 search">
            <input *ngIf="config.filtering" placeholder="{{'Search by VS Code' | translate}}" [ngTableFiltering]="config.filtering"
              class="form-control" (tableChanged)="onChangeTable(config)" />
          </div>
        </section> -->

        <section class="part_search_bar">
          <div class="row no-mar-lr">

            <div class="col-md-4"></div>
            <div class="col-md-4 search_input input-group custom-search-form  pad-top-30" >
              <input type="text" class="form-control" [(ngModel)]="srchValue" class="form-control"
                placeholder="{{'Search by VS Code' | translate}}">
              <span class="input-group-btn">
                <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
                  {{'Search' | translate}}
                </button>
              </span>
            </div>
            <div class="col-md-4"></div>

          </div>
        </section>
        <section class="parts_container mar-btm-40">
          <div class="row_title ">{{'Unlisted VS Code' | translate}}</div>
          <div class="row">
            <div class="col-md-6">
              <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
                [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
                (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
              </pagination>
              <!-- <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="navigateTab($event)" [rows]="rows" [columns]="columns">
                </ng-table> -->
              <table class="table table-bordered text-centered" *ngIf="missingDPData !== undefined">
                <thead>
                  <tr>
                    <th class="text-center">{{'Vendor Scheduler' | translate}}</th>
                    <th class="text-center">{{'Unlisted' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of missingDPData">
                    <td class="text-center">{{data.vendorSchedulerCode}}</td>
                    <td class="text-center hasLink" (click)="navigateTab(data)"><i class="fa fa-plus-circle"
                        aria-hidden="true">&nbsp;</i>{{'Add VS Code' | translate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </section>
    </div>

    <div class="tab-pane" id="VSCode" #createPane>
      <section class="package_subtabs">
        <section class="parts_container">
          <div class="row_title pad-btm-30">{{'Create New VS Code' | translate}}</div>
          <form #f="ngForm" novalidate>
            <div class="row ">
              <div class="col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': name.invalid && f.submitted}">
                  <label for="firstName" class="col-sm-3 col-form-label ">{{'Code' | translate}}:
                    <span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" name="name" [(ngModel)]="VSCode" #name="ngModel"
                      (ngModelChange)="valuechange($event)" required />
                    <div [hidden]="name.valid || (name.pristine && !f.submitted)" class="required-error">
                      {{'Code is Required' | translate}}
                    </div>
                    <div id="mytext" class="required-error"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group nameTitle">{{'English' | translate}}:</div>
              </div>
              <div class="col-md-3">
                <div class="form-group nameTitle">{{'Japanese' | translate}}:</div>
              </div>
            </div>
            <div class="row">
              <div class="offset-md-3 col-md-3">
                <div class="form-group row" [ngClass]="{'has-error': firstNameEng.invalid && f.submitted}">
                  <label for="firstName" class="col-sm-4 col-form-label">{{'First Name' | translate}}<span class="required">*</span>
                  </label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" name="firstNameEng" [(ngModel)]="engFirstName"
                      #firstNameEng="ngModel" required />
                    <small [hidden]="firstNameEng.valid || (firstNameEng.pristine && !f.submitted)" class="required-error">
                      {{'First Name is Required' | translate}}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label for="firstName" class="col-sm-4 col-form-label">{{'First Name' | translate}}</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" name="firstNameJap" [(ngModel)]="japFirstName" />
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="offset-md-3 col-md-3">
                <div class="form-group row">
                  <label for="firstName" class="col-sm-4 col-form-label">{{'Last Name' | translate}}</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" name="lastNameEng" [(ngModel)]="engLastName" />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label for="firstName" class="col-sm-4 col-form-label">{{'Last Name' | translate}}</label>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" name="lastNameJap" [(ngModel)]="japLastName" />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <button [disabled]="userIDTaken" class="btn btn-dark" (click)="openModal(VSCodePopup, f)">{{'Add New VS Code' | translate}}</button>
               </div>
            </div>
            <ng-template #VSCodePopup let-c="close" let-d="dismiss">
              <div class="modal-header">
                <h4 class="modal-title">{{'Are you sure' | translate}}?</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>{{'Are you sure you want to add VS Code' | translate}} {{VSCode}} to {{engFirstName}}?</p>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-dark" (click)="addVSUser(f)">{{'Yes' | translate}}</button>
                <button type="button" class="btn btn-dark-brd" (click)="c('Close click')">{{'No' | translate}}</button>
              </div>
            </ng-template>
          </form>

        </section>
        <div class="row_title_table pad-btm-30">{{'Existing VS Code' | translate}}</div>
        <section class="part_search_bar row">
          <div class="col-sm-6">
            <input type="text" class="form-control searchBar" placeholder="{{'Search by VS Code' | translate}}"
              [(ngModel)]="searchText" />
          </div>
          <div class="col-md-4">
            <button class="btn btn-dark btn-dark-export button" (click)="exportCSV()">
              {{'Export Available VS Code' | translate}}
            </button>
          </div>
        </section>
        <section class="parts_container pad-top-40 mar-btm-40">
          <div class="row">
            <div class=" col-md-10">
              <p-table [value]="VSCodeList | filter: searchText" [responsive]="true" [rows]="100" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[50,100,500,1000]" [paginatorPosition]="'top'">
                <!-- <p-column field="vendorSchedulerCode" header="{{'VS Code' | translate}}" [sortable]="true" [filter]="true"
                  filterPlaceholder="{{'Search by VS Code' | translate}}">
                  <ng-template let-row="rowData" pTemplate="body">
                    <div (click)="editRowDetails(editDetails, row)">{{row.vendorSchedulerCode}}</div>
                  </ng-template>
                </p-column>
                <p-column field="vendorSchedulerFirstNameEN" header="{{'First Name' | translate}}[Eng]" [sortable]="true"
                  [filter]="true" filterPlaceholder="{{'Search by First Name[Eng]' | translate}}">
                </p-column>
                <p-column field="vendorSchedulerLastNameEN" header="{{'Last Name' | translate}}[Eng]" [sortable]="true"
                  [filter]="true" filterPlaceholder="{{'Search by Last Name[Eng]' | translate}}">
                </p-column>
                <p-column field="vendorSchedulerFirstNameJP" header="{{'First Name' | translate}}[Jap]" [sortable]="true"
                  [filter]="true" filterPlaceholder="{{'Search by First Name[Jap]' | translate}}">
                </p-column>
                <p-column field="vendorSchedulerLastNameJP" header="{{'Last Name' | translate}}[Jap]" [sortable]="true"
                  [filter]="true" filterPlaceholder="{{'Search by Last Name[Jap]' | translate}}">
                </p-column> -->
                <ng-template pTemplate="header">
                  <tr>
                      <th pSortableColumn="vendorSchedulerCode" style="width:20%">{{'Search by VS Code' | translate}} <p-sortIcon field="vendorSchedulerCode"></p-sortIcon></th>
                      <th pSortableColumn="vendorSchedulerFirstNameEN" style="width:20%">{{'First Name' | translate}} <p-sortIcon field="vendorSchedulerFirstNameEN"></p-sortIcon></th>
                      <th pSortableColumn="vendorSchedulerLastNameEN" style="width:20%">{{'Last Name' | translate}}<p-sortIcon field="vendorSchedulerLastNameEN"></p-sortIcon></th>
                      <th pSortableColumn="vendorSchedulerFirstNameJP" style="width:20%">{{'First Name' | translate}} <p-sortIcon field="vendorSchedulerFirstNameJP"></p-sortIcon></th>
                      <th pSortableColumn="vendorSchedulerLastNameJP" style="width:20%">{{'Last Name' | translate}} <p-sortIcon field="vendorSchedulerLastNameJP"></p-sortIcon></th>
                  </tr>
                  <tr>
                    <th>
                      <p-columnFilter type="text" field="vendorSchedulerCode"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter type="text" field="vendorSchedulerFirstNameEN"></p-columnFilter>
                   </th>
                   <th>
                  <p-columnFilter type="text" field="vendorSchedulerLastNameEN"></p-columnFilter>
                  </th>
                  <th>
                     <p-columnFilter type="text" field="vendorSchedulerFirstNameJP"></p-columnFilter>
                   </th>
                  <th>
                      <p-columnFilter type="text" field="vendorSchedulerLastNameJP"></p-columnFilter>
                 </th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-value>
                  <tr>
                      <td (click)="editRowDetails(editDetails, value)">{{value.vendorSchedulerCode}}</td>
                      <td>{{value.vendorSchedulerFirstNameEN}}</td>
                      <td>{{value.vendorSchedulerLastNameEN}}</td>
                      <td>{{value.vendorSchedulerFirstNameJP}}</td>
                      <td>{{value.vendorSchedulerLastNameJP}}</td>
                  </tr>
              </ng-template>
              </p-table>
            </div>
          </div>
        </section>

        <ng-template #editDetails let-c="close" let-d="dismiss">
          <div class="modal-header">
            <h4 class="modal-title">{{'Edit Details' | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="vsCode" class="col-form-label col-sm-3">{{'VSCODE' | translate}}:</label>
              <div class="col-sm-4">
                <input type="text" class="form-control" name="VSCodeEdit" [(ngModel)]="editVSCode" disabled />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="firstNameEng" class="col-form-label">{{'First Name' | translate}}[Eng]:</label>
                  <div class="">
                    <input type="text" class="form-control" name="firstNameEng" [(ngModel)]="editFirstName" required />
                    <small *ngIf="!editFirstName" class="required-error">
                      {{'First Name is Required' | translate}}
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="firstNameJap" class="col-form-label">{{'First Name' | translate}}[Jap]:</label>
                  <div class="">
                    <input type="text" class="form-control" name="firstNameJap" [(ngModel)]="editFirstNameJap" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lastNameEng" class="col-form-label">{{'Last Name' | translate}}[Eng]:</label>
                  <div class="">
                    <input type="text" class="form-control" name="lastNameEng" [(ngModel)]="editlastName" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="lastNameJap" class="col-form-label">{{'Last Name' | translate}}[Jap]:</label>
                  <div class="">
                    <input type="text" class="form-control" name="lastNameJap" [(ngModel)]="editlastNameJap" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="col-md-2 btn btn-dark" [disabled]="!editFirstName" (click)="saveChanges()">{{'Save'
              | translate}}</button>
            <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' |
              translate}}</button>
          </div>
        </ng-template>
      </section>
    </div>
  </div>
</section>